export default __webpack_public_path__ + "static/second-image-363aae09e6c50d84d58ef495330a186a.gif";